import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { RootState } from "../../redux/reducer";
import { connect, ConnectedProps } from "react-redux";
import "react-tabs/style/react-tabs.css";
import SummaryTab from "./KJTabs/SummaryTab"
import ProductTab from "./KJTabs/ProductTab";
import ByStoreTab from "./KJTabs/ByStore";
import SinageTab from "./KJTabs/SignageView"
import useClasses from "../../common/UseClasses";

const useStyles = () => ({
    root: {
      width: "100%",
    },
    container: {
      maxHeight: 440,
    },
  });


type PropsFromRedux = ConnectedProps<typeof connector>;
type KJMainProps = PropsFromRedux & {};
const KJMainScreen: React.FC<KJMainProps> = ({ ...rest }) => {

  const classes: any = useClasses(useStyles);  
  // const classes = useStyles();

    return (
        <div
        style={{
          display: "flex",
          flex: 1,
          padding: 16,
          flexDirection: "column",
        }}
      >

      <Tabs>
        <TabList>
          <Tab>Summary</Tab>
          <Tab>By Store</Tab>
          <Tab>Product Data</Tab>
          <Tab>Signage View</Tab>
        </TabList>
        <TabPanel>
            <SummaryTab />
        </TabPanel>
        <TabPanel>
            <ByStoreTab />
        </TabPanel>
        <TabPanel>
          <ProductTab/>
        </TabPanel>
        <TabPanel>
          <SinageTab/>
        </TabPanel>
    </Tabs>
    </div>
    );
};

const mapState = (state: RootState) => ({});

const mapDispatch = {};

const connector = connect(mapState, {
    
});

export default connector(KJMainScreen);
